import { Category } from './enums';
import { TemplateParams } from 'types/assets';

export const templatesByCategory: Record<Category, string[]> = {
  [Category.FashionApparel]: ['2936', '2348', '2684', '3011', '4779', '4704'],
  [Category.BeautyPersonalCare]: ['3173', '2975', '2901', '2392', '4844', '5044'],
  [Category.HomeLiving]: ['3173', '3212', '2010', '2966', '4843', '5223'],
  [Category.ElectronicsGadgets]: ['2860', '2964', '3010', '2357', '1739', '2202'],
  [Category.SportOutdoors]: ['1762', '2585', '3154', '2592', '5121', '5476'],
  [Category.FoodBeverages]: ['2949', '3030', '3215', '4310', '4770', '2456'],
  [Category.BooksMediaArt]: ['5047', '2207', '4980', '5344', '4596', '5662'],
  [Category.Other]: ['3173', '2936', '2175', '2514', '1762', '2854'],
};

export const templates: Record<string, TemplateParams> = {
  '2936': {
    msid: 'd74e8fd5-924e-47f7-ab48-e81dc41e1761',
    siteUrl: 'https://www.wix.com/demone2/t-shop',
    assets: {
      desktop: '/templates/image/ed525a64f913f03ddd9f18c3621c177acd17104baa3a5df3e488b746c2213cdb1626874515043.jpg',
      mobile: '/templates/image/9223efcf6c6676c63920198693847a599dd4d3d758d72bd66454f4bc22f0fc791625750138735.jpg',
    },
  },
  '2348': {
    msid: 'e51d7741-76c0-4f61-a133-f7af421c3846',
    siteUrl: 'https://www.wix.com/demone2/womens-apparel-brand',
    assets: {
      desktop: '/templates/image/efce9dffdb7479619d0265ad936941a7c145d6ea40eb2e2b2d261c539177d23e1703407170595.jpg',
      mobile: '/templates/image/2197570a3dc2cd995db89c39bdb8828f2eb47664eac81aa29477cd6ebde8eb781703407175443.jpg',
    },
  },
  '2684': {
    msid: '4fcd770d-ab1c-4530-ada2-1920b43d7925',
    siteUrl: 'https://www.wix.com/demone2/loungewear-store',
    assets: {
      desktop: '/templates/image/e107c5f2973d26d6346fd1611e524efb2e62173aead26ea6a8d8747620a7d4371594561681992.jpg',
      mobile: '/templates/image/7bc159c2032cb2dd4056edfa210fe15ed0fb1517f91b0269b2ae0bff1d2679f31594561698793.jpg',
    },
  },
  '3011': {
    msid: 'bdb4e3ef-cb90-4d10-9a09-65893e11dc0c',
    siteUrl: 'https://www.wix.com/demone2/moda',
    assets: {
      desktop: '/templates/image/7554c6ea35a2c075329bf79f6db1c0e7880b0efd20fa918ca885bbc371bebba71641818311686.jpg',
      mobile: '/templates/image/4b0b2eb5fa3ad03e38e8c242a741aad40db237e60de6650ef8832c3ce01b8c1d1641818317979.jpg',
    },
  },
  '4779': {
    msid: '46357a83-405f-48cf-9a2f-edbfcaf55a86',
    siteUrl: 'https://www.wix.com/sgtemplates/bmorga',
    assets: {
      desktop: '/templates/image/e3a9cf999479658f4a49315b6870a100d6124774ce95d54ebcf509a12ea4212a1744701719690.jpg',
      mobile: '/templates/image/0e2cc157c66761fa01fa9e285a68906bb6f339f26200315701d3f4b3096fe4041744701718879.jpg',
    },
  },
  '4704': {
    msid: '5376b748-c9c2-4be5-bc6b-dc89c309d23c',
    siteUrl: 'https://www.wix.com/demone2/m-silva',
    assets: {
      desktop: '/templates/image/324d6cb96d3d0c3754fb5098e729b8117465a1ba4db718b878e97f9dc4304aea1744109447913.jpg',
      mobile: '/templates/image/97e7bd06970661a63ec39f4d35eefacacddd06c31a58c5dd48d0821a8fea4d621744109447368.jpg',
    },
  },
  '3173': {
    msid: 'e5270f42-25b8-4f7a-aafb-2e609a06e17f',
    siteUrl: 'https://www.wix.com/demone2/re-vert',
    assets: {
      desktop: '/templates/image/535d1540333b3111cd179a45665f15ef4036104833a187d6901160edc934fcc01675844785106.jpg',
      mobile: '/templates/image/9acbc2ef7ac23f6554d26f2166d64fba6114a32692b8640009e32598e63c06041675844789411.jpg',
    },
  },
  '2975': {
    msid: '823f5332-5b27-42be-bf35-48c75e5ed908',
    siteUrl: 'https://www.wix.com/demone2/serenity',
    assets: {
      desktop: '/templates/image/e1f7cdf528dd33fdb1ad1c1f6dcb383511832e93aa9b773c694d28a30a90bcb81635254029964.jpg',
      mobile: '/templates/image/f588a9bc416eda659bf84130f57153dac8dc7f818b6b1ae7319bb2ea26f9180a1635254042804.jpg',
    },
  },
  '2901': {
    msid: '57911fa8-a432-45c0-b84f-67f718513b29',
    siteUrl: 'https://www.wix.com/demone2/noelle',
    assets: {
      desktop: '/templates/image/c4b12722f50791fe162dd5a27afa217ced8d5bd6b10d8d1c80e5ad0490eff63f1622375935018.jpg',
      mobile: '/templates/image/0f1759341470b841142b6fad0e8c23a25c92efe544ebcbab50747735d12068121622376102757.jpg',
    },
  },
  '2392': {
    msid: '5a0ef9eb-8698-46c6-80a0-ff9d86812d92',
    siteUrl: 'https://www.wix.com/demone2/hair-extension-lash',
    assets: {
      desktop: '/templates/image/0d41467b8d03ef06e1fea12d4bd45cc128e6b02454e2ca28188e68b8577982ca1731416932469.jpg',
      mobile: '/templates/image/38b658a4e69ae7926ba3d9cf37ac38538bb7b182f1df0221438a7891007c9be11731416927442.jpg',
    },
  },
  '4844': {
    msid: '32247b67-b460-4f6e-aa4e-47c0f212929d',
    siteUrl: 'https://www.wix.com/sgtemplates/shelt-essential',
    assets: {
      desktop: '/templates/image/02424eb54ff684515ee619020b7c723ed6662b295ea2291968aa39f2b917ec9a1744702112515.jpg',
      mobile: '/templates/image/1e0b9382a171c8215db112dbbac311ed4f015fac8e7e64313af17ea12ba704de1744702111980.jpg',
    },
  },
  '5044': {
    msid: '508da751-8164-419d-8ba5-1888abd85532',
    siteUrl: 'https://www.wix.com/sgtemplates/bathbo',
    assets: {
      desktop: '/templates/image/1b0ed08adf3ed9c0f4d716d022ec8763c7cb71ab29efa6c5f8542fed1ea490571745312763575.jpg',
      mobile: '/templates/image/99ce0c076e848694f6dec3f9005c59ef4dfa40d2f61f73dcae1eeb9b43e5f92c1745312763232.jpg',
    },
  },
  '3212': {
    msid: '3a5ca34d-a5d5-4635-8856-9634def8684e',
    siteUrl: 'https://www.wix.com/demone2/gift-shop-jsy',
    assets: {
      desktop: '/templates/image/7c912ba29cf8c7e34689f8e65ed0f5879eeade067df1b8895f0234c310bc86cf1702801944924.jpg',
      mobile: '/templates/image/66b30d99ae1522c989f65c98c91b070f1fea67e83f63b78517d4f13c5e3671f41702801949529.jpg',
    },
  },
  '2010': {
    msid: '45779429-948f-4e77-a8b4-2f2883145e3c',
    siteUrl: 'https://www.wix.com/demone2/ceramic-studio',
    assets: {
      desktop: '/templates/image/fb8893ecc86a4f0d2136c1b71c86166bb5c83e378c009191d0f515b2fdcca6c51703414231597.jpg',
      mobile: '/templates/image/e17eba8f82f2ea764faeb2d88bc04f3d59bdde687d0ad8a6178afa1fafecf85c1703414203860.jpg',
    },
  },
  '2966': {
    msid: '7e0d4f62-cac0-41d7-80fe-1a5a1cb8d4d8',
    siteUrl: 'https://www.wix.com/demone2/sprout',
    assets: {
      desktop: '/templates/image/62fbc63aa8ee5b632a7e817ebc8c107f1aa7467a03f8df25ad0c1a7eccc3754c1631517092426.jpg',
      mobile: '/templates/image/201c663c3d1dda557cb33eb32ea0c68ccf28bb5e4486565c39bd0c7ef0d50ed81631513480147.jpg',
    },
  },
  '4843': {
    msid: 'f2815e67-5fb9-4dee-a07f-cbbc18c419f5',
    siteUrl: 'https://www.wix.com/sgtemplates/t-leclerc',
    assets: {
      desktop: '/templates/image/3539bddade40bd79d98260072962c7b642b5a9932989fa83c74ed2457d706ee31744702106274.jpg',
      mobile: '/templates/image/3f56a4d2fd3f2f425fc4842a9b0d2f4c29ef28043c6978253439b75db2a38e5b1744702105720.jpg',
    },
  },
  '5223': {
    msid: '688224c2-51bd-4248-8871-e3dfbd9237c4',
    siteUrl: 'https://www.wix.com/sgtemplates/k-vladislav',
    assets: {
      desktop: '/templates/image/330bd3fd9ad7e99c18977370ebcf1cd321db5036254e8fef386d7970f9cc11fc1748953486483.jpg',
      mobile: '/templates/image/6c6bd353d2e14d01e36e82145c59ef396e901dd6f9fac1ebdea3ad510387a9041748953486409.jpg',
    },
  },
  '2860': {
    msid: 'b13ae6bf-ed09-484d-a708-707c0bd807e7',
    siteUrl: 'https://www.wix.com/demone2/techshed',
    assets: {
      desktop: '/templates/image/34041b678f8322dd95446ca0e0ee3d4caebb59008a7aa3f8922a8461c268fe6d1617888011678.jpg',
      mobile: '/templates/image/393c65e591c8198f94527ce3bdf871d399c3ee0cd39dfbc85d2eaafd73c1ba301616683268864.jpg',
    },
  },
  '2964': {
    msid: '186a4581-0aef-4fb0-8ee9-5b400d452ff9',
    siteUrl: 'https://www.wix.com/demone2/trackmate',
    assets: {
      desktop: '/templates/image/36f43fd77b7af2ba582969c31de1b0e17a79318199328f9bca8b444825d012d71631446807689.jpg',
      mobile: '/templates/image/f17e913b8d139cf584b915c6a23d94fc37f3c4cff3f494121a1925f8f03e014a1631446833929.jpg',
    },
  },
  '3010': {
    msid: '82a35a58-5cde-44f4-8f4b-859c043a52e3',
    siteUrl: 'https://www.wix.com/demone2/arcade',
    assets: {
      desktop: '/templates/image/2d8b6a80e221bac22b61989418024b52a15e013fb6fa16dc249357d2e7a8c1a41641744479755.jpg',
      mobile: '/templates/image/29a8dcae9a4081f3f6b0566f540f80cf240221664aee2e5cdcbd481a33eea0a41641744500497.jpg',
    },
  },
  '2357': {
    msid: '20367593-361b-40e5-8128-b6dc9114adf6',
    siteUrl: 'https://www.wix.com/demone2/headphones-lp',
    assets: {
      desktop: '/templates/image/dfa9f863fc83c36f632b86bc263a5250269e7aa8affdec8b59467d503e8834361627993950608.jpg',
      mobile: '/templates/image/b4042bf77e9e3e0bcf769eabe99d84b627e011322d6ce776ac368f4e5e43a6ca1627993958934.jpg',
    },
  },
  '1739': {
    msid: 'b0ee2dd4-d99b-42b4-a04e-d3a80588ed27',
    siteUrl: 'https://www.wix.com/demone2/home-tech-store',
    assets: {
      desktop: '/templates/image/4391abe3b010d3d48a6220b34f9e7d05ba806b49231112f20f1ed25e47d752bb1731416453466.jpg',
      mobile: '/templates/image/9a8efc54cf70e698ef94b17b9267af715e7381ca33af275128c4099f0ffdab2c1731416469249.jpg',
    },
  },
  '2202': {
    msid: '0e1b8493-bd73-4d97-8b82-d01992e4e5c7',
    siteUrl: 'https://www.wix.com/demone2/phone-and-tablet',
    assets: {
      desktop: '/templates/image/c684c394a078ce5890e7ad69ec150da63a0a21dc769015f9e4bc4d3746386673.jpg',
      mobile: '/templates/image/f1b11b0b109fef94a099d05b43939be5de6844e7f7b9ccd13aa25b373d1c6eb3.jpg',
    },
  },
  '1762': {
    msid: 'e63c8261-1beb-4131-a5f2-b64222d95690',
    siteUrl: 'https://www.wix.com/demone2/outdoor-bags',
    assets: {
      desktop: '/templates/image/8fb80f31509b48073926b5ea1044897c24d1726cdcffe236f88433ac7fa0553f1676468814740.jpg',
      mobile: '/templates/image/f436775688f8879ac04fe6761176942643c83aa3fb6dc776d87de8f0b1a82ec71676468850599.jpg',
    },
  },
  '2585': {
    msid: '287f80ad-c14a-48d9-95b7-7ee8098b6cef',
    siteUrl: 'https://www.wix.com/demone2/sports-nutrition',
    assets: {
      desktop: '/templates/image/f61f59c1039f153f409c797636e54b0c3a6b3974588db5ee508859db5d00e8421731416989325.jpg',
      mobile: '/templates/image/d851eff48f847c129dcaf3d477f54b0ca708c905cbdea68846cb9a04246e153c1731416984621.jpg',
    },
  },
  '3154': {
    msid: '531f03c3-3221-4c34-aeb7-61450b2d4b7d',
    siteUrl: 'https://www.wix.com/demone2/champplace',
    assets: {
      desktop: '/templates/image/6e53a3c58adb3bac530f44251c1d70ad9a1fcbf0bc0e6cbe1e95a2a88a7d7f661664796521452.jpg',
      mobile: '/templates/image/4dc566ffd8844fbe9fa6236df433cbbe9ced2624dc6f7bc3914964ce8d7a7a311664796537747.jpg',
    },
  },
  '2592': {
    msid: 'a7d396b7-c546-46e3-b54c-f9f4736e9b31',
    siteUrl: 'https://www.wix.com/demone2/online-ski-shop',
    assets: {
      desktop: '/templates/image/478aae6298f2ffc4f4184c7cf5748c03766b50c59e905c5848d6531c291760651585228536562.jpg',
      mobile: '/templates/image/2d39083e1ec2d7ea45d956e110cf7c9ec0cf06c207a991633817441b81fe11501585229337608.jpg',
    },
  },
  '5121': {
    msid: '4659ff9c-a796-4333-b64a-b9fa25f616ee',
    siteUrl: 'https://www.wix.com/sgtemplates/doldgekhan',
    assets: {
      desktop: '/templates/image/94dce5e48ac9bfa87c1e1a2e33644a238cf17f59ebc039dc90f8be619af1a9e91748347847845.jpg',
      mobile: '/templates/image/46671746d63e1435bfb26e20c1c03357272c7033d807722b3c4229cf2a03a1671748347847749.jpg',
    },
  },
  '5476': {
    msid: '54f377f6-9f9a-4136-bd98-7a3939707d13',
    siteUrl: 'https://www.wix.com/sgtemplates/jboisde',
    assets: {
      desktop: '/templates/image/2aab439021c40d4abc3636bfefa4ea0f3173f86de6a3cb9f3c5e1b721c64bda61750147944481.jpg',
      mobile: '/templates/image/5987400bbc0d0e94001d2088eb7a4688376affde41085a2d668410b6a9795a421750147943469.jpg',
    },
  },
  '2949': {
    msid: '188f4e86-deb6-4fc6-9aa9-e79f1c921277',
    siteUrl: 'https://www.wix.com/demone2/clovers',
    assets: {
      desktop: '/templates/image/7f55d3d81719567460c6999054b9fd7a8d45b2de890026527cbd8bc4b59930b41628686153199.jpg',
      mobile: '/templates/image/9586f969ed3b6f817d96c7bfc1c8cde2b9f98705cb11a461110fd2327bd6a14d1628751265412.jpg',
    },
  },
  '3030': {
    msid: 'e66ed1bc-a3db-4b18-907a-f106278f0edd',
    siteUrl: 'https://www.wix.com/demone2/pure-flave',
    assets: {
      desktop: '/templates/image/786a86f9395344380578c12e1d7179e0a04cb8cf89786a6cdd06b2ea446e01841645012930735.jpg',
      mobile: '/templates/image/f74bf0de71d2808d76b724b9587904f29f793113e44d80bcd9d31f288bd4f6601645012953808.jpg',
    },
  },
  '3215': {
    msid: '2a6c805b-c189-4972-a03c-274f1ce01675',
    siteUrl: 'https://www.wix.com/demone2/brew',
    assets: {
      desktop: '/templates/image/3a0105cdcfd30d5ee499736978f8c5497bb843b52b5a8f83c020cbb15ec468c71702478124760.jpg',
      mobile: '/templates/image/8d99e0faaa29385570158a0ab4a54e4b34a92353fb4a947874cffc5516a21fdb1702478138312.jpg',
    },
  },
  '4310': {
    msid: 'c0b3c925-0f8b-4359-bf71-9bc6ceea1beb',
    siteUrl: 'https://www.wix.com/sgtemplates/cupandweber',
    assets: {
      desktop: '/templates/image/6056f035f0f465e43705690771aa44b0ccdd4740704a51c58f8d3d581050c2511742911668316.jpg',
      mobile: '/templates/image/5667befc6cd8bf18230d9d8223056323935488d2c3cf00412336659d29dfda821742911667290.jpg',
    },
  },
  '4770': {
    msid: '5f907a4f-b7d9-4c54-b3f9-db445d3de8df',
    siteUrl: 'https://www.wix.com/sgtemplates/bois-bosco-coffee',
    assets: {
      desktop: '/templates/image/1cd095792f02a0401c3c6e4cb65466204d27a563c9afa09953e23fb4a21289591744701662574.jpg',
      mobile: '/templates/image/47d64f621765fc5d14d937f6d10637fa00f738989b368f4cd0277a0c970c9e4f1744701662013.jpg',
    },
  },
  '2456': {
    msid: '41ac5804-80c3-425a-8080-2194184891d2',
    siteUrl: 'https://www.wix.com/demone2/chicken-farm',
    assets: {
      desktop: '/templates/image/4a78361da86728fd909b248e27040f1aef2c0a9999949c2e5e54dcc9f0068958.jpg',
      mobile: '/templates/image/0d590657e57501b9fe25cfd288cad5214285a14eea351efe7537d28492b23565.jpg',
    },
  },
  '5047': {
    msid: '879cb9a2-9233-42e4-b5ae-98db04fb4771',
    siteUrl: 'https://www.wix.com/sgtemplates/shawthorne',
    assets: {
      desktop: '/templates/image/6b953f29fbeba7920ff082249fb7d55774c2f230949ee1059a19cd6885d6843d1745312782270.jpg',
      mobile: '/templates/image/2700e993c897c4e9551a16ccdddadce56ecb806071fc703b42549eb26843f8511745312781717.jpg',
    },
  },
  '2207': {
    msid: '8cb1beb4-a278-4226-8801-94f2a9def745',
    siteUrl: 'https://www.wix.com/demone2/featured-book-store',
    assets: {
      desktop: '/templates/image/a0f1b7e73d17df955910d58eb3f404016b266853215ee8d1ebff256d436471e0.jpg',
      mobile: '/templates/image/9fa3a0988da1abe81d6491fa559e4e460ad5adadd20f48b6112dc05e542b7dfe.jpg',
    },
  },
  '4980': {
    msid: '576324f8-b3c2-44fe-9ea7-c22f8375e9c9',
    siteUrl: 'https://www.wix.com/sgtemplates/l-robinson',
    assets: {
      desktop: '/templates/image/1b262cf5380a021a902128a67d558c6bb8da9f1ac322b74546d6d86f720d7fcb1745312344700.jpg',
      mobile: '/templates/image/7e191b4ad18d592b4b15fa173b073f563fb085a7f3c2e1d994ccfda1f9456c951745312344157.jpg',
    },
  },
  '5344': {
    msid: 'b39fed39-bb59-45a4-9e81-d406f1fd3bd5',
    siteUrl: 'https://www.wix.com/sgtemplates/l-mulvaney',
    assets: {
      desktop: '/templates/image/c0538fa54f784af708c1039a80cd76bc584b2c0120fde2ab1ffe783d9f00c7931748954395176.jpg',
      mobile: '/templates/image/bf2bf5d1cca7206e7306a096146a619730e337de27a2bcfbd2f944d73f38c4071748954395081.jpg',
    },
  },
  '4596': {
    msid: 'da4964fb-4543-4305-8b93-f182fbf1ea14',
    siteUrl: 'https://www.wix.com/sgtemplates/r-osullivan',
    assets: {
      desktop: '/templates/image/08201d5aeec5c0ce689f07168a807c4d65580c817a3e940948349fd57b337c2a1744106848770.jpg',
      mobile: '/templates/image/01c31a7d7624e7bb55054d3e36869a5bd527c64e65fa6a6363c5a87aabbbafcc1744106848061.jpg',
    },
  },
  '5662': {
    msid: '00e2a511-8706-4d81-8dac-2fc2efcb2684',
    siteUrl: 'https://www.wix.com/demone2/c-balthazar',
    assets: {
      desktop: '/templates/image/cb73c009add6a557f6496a9f82ef333195f0b2262696a9c02b1f268963b7d2be1751351162641.jpg',
      mobile: '/templates/image/d53ec5c721b7e6698609e1216e9b376d2ae49a345e430553c98f2877de3f9f3a1751351162586.jpg',
    },
  },
  '2175': {
    msid: 'f9bf8eee-6569-46fa-b4e8-e6b8ca8990c1',
    siteUrl: 'https://www.wix.com/demone2/tote-bag-store',
    assets: {
      desktop: '/templates/image/396983f7acdfebd5b6bdfe1d7428453298b2b08b3a634d4bd0215fcc2029ccfc1703406649021.jpg',
      mobile: '/templates/image/ea047bc3ed1a2bc5011edd2bd2640b44c377e7041e9ca93b8a8e5a7686f79d0a1703406661568.jpg',
    },
  },
  '2514': {
    msid: 'ca11886c-1135-4156-b799-ca8b8b7442b9',
    siteUrl: 'https://www.wix.com/demone2/womens-accessories',
    assets: {
      desktop: '/templates/image/70b2c8ad83f0be28a63b715a5e9f9703e9198f52cc2ee5f8462b30211b640e301703406761636.jpg',
      mobile: '/templates/image/2db504a1897c09e85c3b5da8f294fa9ec39d773ae7c497780bb9615617fdcd521703406764698.jpg',
    },
  },
  '2854': {
    msid: 'e523a71a-72d0-4cf2-94ce-e43e7ee5815e',
    siteUrl: 'https://www.wix.com/demone2/lou-paperie',
    assets: {
      desktop: '/templates/image/01f4ead8c0a0283f5b8cf3f6639d8931eb8bafb401c1029ef6f5b5ae0a620ff81638778283400.jpg',
      mobile: '/templates/image/4fa7962a1b75c3d97d29532fa8e2c0e4e65b09abaa95ee010d4b02f8501b091c1638778289468.jpg',
    },
  },
};
